<div class="notification-dropdown" [class.sidebar-notifications]="sidebar()" [class.compact]="compact()">
  <!-- Bell Button with Badge -->
  <button #trigger type="button"
    class="notification-bell"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen()" aria-controls="sidebar-notifications-panel"
    [attr.aria-label]="'Notifications (' + unreadCount() + ' sin leer)'"
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="20" 
      height="20" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      stroke-width="2" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
    
    @if (sidebar()) { <span class="notification-label">Notifications</span> }
    <span class="notification-badge" *ngIf="unreadCount() > 0">
      {{ unreadCount() > 99 ? '99+' : unreadCount() }}
    </span>
  </button>

  <!-- Dropdown Panel -->
  <section id="sidebar-notifications-panel" class="notification-panel" aria-label="Notifications" *ngIf="isOpen()">
    <div class="notification-header">
      <h4>Notifications</h4>
      <a [routerLink]="'/uco/notifications'" class="view-all-link" (click)="closeDropdown()">
        View all notifications
      </a>
    </div>

    <div class="notification-list" (scroll)="onScroll($event)">
      <div class="notification-empty" *ngIf="notifications().length === 0 && !isLoading()">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="48" 
          height="48" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="1.5"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          <line x1="1" y1="1" x2="23" y2="23"></line>
        </svg>
        <p>No notifications</p>
      </div>
      
      <ng-container *ngIf="notifications().length > 0">
        <button type="button"
          *ngFor="let notification of notifications(); trackBy: trackByNotification"
          class="notification-item"
          [class.unread]="!notification.read"
          (click)="onNotificationClick(notification)"
        >
          <div class="notification-indicator"></div>
          <div class="notification-content">
            <h5 class="notification-title">{{ notification.title }}</h5>
            <p class="notification-body">{{ formatMessage(notification.message) }}</p>
            <span class="notification-time">{{ formatTime(notification.createdAt) }}</span>
          </div>
        </button>
      </ng-container>

      <!-- Loading indicator -->
      <div class="notification-loading" *ngIf="isLoading()">
        <i class="fa fa-spinner fa-spin"></i>
        <span>Loading...</span>
      </div>
    </div>
  </section>
</div>
